module.exports = __webpack_public_path__ + "img/palette-3-bg_en.4155cf6.jpg";